import {Filter} from '@shared/models/filter.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {Utilities} from '@shared/utilities/utilities.model';

export class AlertsFilter extends Filter {
	txt_search_index: string;
	txt_textual_search: string;
	is_last_message_read: boolean;
	txt_senders: string;
	date_thread_from: string;
	date_thread_to: string;
	id_order: string;

	constructor(model?: any) {
		super();
		if (model) {
			this.txt_search_index = model.txt_search_index;
			this.txt_textual_search = model.txt_textual_search;
			this.is_last_message_read = model.is_last_message_read;
			this.txt_senders = model.txt_senders;
			if (!Utilities.isVoid(model.date_thread_from)) {
				if (typeof model.date_thread_from === 'string') {
					this.date_thread_from = model.date_thread_from;
				} else {
					this.date_thread_from = DateUtilities.getStringFromMoment(model.date_thread_from, DateUtilities.onlyDate);
				}
			}
			if (!Utilities.isVoid(model.date_thread_to)) {
				if (typeof model.date_thread_to === 'string') {
					this.date_thread_to = model.date_thread_to;
				} else {
					this.date_thread_to = DateUtilities.getStringFromMoment(model.date_thread_to, DateUtilities.onlyDate);
				}
			}
		}
	}

	newFilter(model?: any): AlertsFilter {
		return new AlertsFilter(model);
	}

	clone(): AlertsFilter {
		return new AlertsFilter(this);
	}

	public getFilterUrl(): string {
		let filterUrl = Utilities.getQuery(this);
		if (!Utilities.isVoid(this.date_thread_from) && Utilities.isVoid(this.date_thread_to)) {
			filterUrl += '&date_thread_to=31/12/2099';
		}
		if (!Utilities.isVoid(this.date_thread_to) && Utilities.isVoid(this.date_thread_from)) {
			filterUrl += '&date_thread_from=01/01/1900';
		}
		return filterUrl;
	}
}
